module.exports = __webpack_public_path__ + "static/media/21ECLAC3.48b9e07a.jpg";